exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selected-car {\n  display: inline;\n  margin-right: .4rem; }\n", ""]);

// exports
